export default "__VITE_ASSET__C5QCrQ6t__"